import { render, staticRenderFns } from "./PremiumLives.vue?vue&type=template&id=1f343061"
import script from "./PremiumLives.vue?vue&type=script&lang=js"
export * from "./PremiumLives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports